// extracted by mini-css-extract-plugin
export default {"link":"BUYzIN","title":"yL_gto","timer":"jLMdP_","icon":"GJ5new"};